export default "__VITE_ASSET__Cje$XyE5__"